import once from 'once';
const throwErrorOnce = once((isSSR) => {
    throw new Error(`Simulated Error: Widget, ${isSSR ? 'SSR' : 'CSR'}`);
});
export const useSimulateError = (wfConfig) => {
    const { simulateError, isSSR } = wfConfig;
    if (simulateError) {
        throwErrorOnce(Boolean(isSSR));
    }
};
//# sourceMappingURL=use-simulate-error.js.map